import { Outlet, createFileRoute, redirect, useLocation } from "@tanstack/react-router"
import { useEffect } from "react"
import Auth from "@/constants/Auth"
import Constants from "@/constants/Constants"
import LocalStorage from "@/utilities/LocalStorage"
import AuthLayout from "@/layout/AuthLayout"

const WithProjectLayout = () => {
  const location = useLocation()

  useEffect(() => {
    let currentPath = Constants.sidebarMenuItems.filter(e => e.url === location?.pathname)[0]
    if (!currentPath) {
      const paths = location?.pathname.split("/").filter(e => e !== "")
      currentPath = Constants.sidebarMenuItems.find(e => e.url === `/${paths[0]}`) ?? currentPath
    }
    if (
      location?.pathname !== "/" &&
            location?.pathname !== "/login" &&
            location?.pathname !== Auth.projectSelectPath
    ) {
      localStorage.setItem("lastVisitedPage", location.pathname)
    }
  }, [location])

  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  )
}

export const Route = createFileRoute("/_auth/_withProject")({
  beforeLoad: () => {
    const selectedCompany = LocalStorage.selectedCompany()
    if (!selectedCompany) {
      throw redirect({
        to: Auth.projectSelectPath,
      })
    }
  },
  component: WithProjectLayout,
})


